import React from "react";
import styled, { css } from "styled-components";

const InputStep = ({
  value,
  inputRef,
  inputType,
  placeholder,
  onKeyPress,
  onChange,
  onClick,
  buttonText,
  onFocus,
  withInput = true,
}) => (
  <InlineContent>
    {withInput && (
      <TextInput
        innerRef={inputRef}
        placeholder={placeholder}
        className="input"
        type={inputType || "email"}
        value={value}
        onKeyPress={onKeyPress}
        onChange={onChange}
        onFocus={onFocus}
      />
    )}
    <InlineButton onClick={onClick}>{buttonText}</InlineButton>
  </InlineContent>
);

const Button = styled.button`
  width: 100%;
  max-height: 60px;
  display: flex;
  position: relative;
  justify-content: center;
  border-radius: 4px;
  background: black;
  border: 2px solid currentColor;
  border-color: transparent;
  color: #fff;
  white-space: nowrap;
  font-weight: 500;
  line-height: 1.4;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 8px 16px;
  font-family: Montserrat;
  font-weight: 700;
  color: white;
  font-size: 15px;
  text-transform: uppercase;
`;

const PrimaryButton = styled(Button)`
  background: #3e8dff;
  flex: 2;
`;

const TextInput = styled.input`
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: #ffffff;
  color: white;
  height: 42px;
  font-size: 14px;
  border-radius: 4px 0 0 4px;
  padding: 8px;
  width: 100%;
  margin-right: 0px;

  font-family: Montserrat;
  font-size: 15px;
  font-weight: 700;
  padding: 4px 12px;

  color: #333;

  &::placeholder {
    font-weight: 500;
    color: #888;
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    border-radius: 4px;
    margin-bottom: 24px;
  }
`;

const InlineContent = styled.div`
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: 500px) {
    display: block;
    width: 100%;
    margin-bottom: 24px;
  }
`;

const InlineButton = styled(PrimaryButton)`
  border-radius: 0 4px 4px 0;
  @media screen and (max-width: 500px) {
    border-radius: 4px;
  }
`;

export default InputStep;
